/* eslint-disable react/prop-types */
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {useState} from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const ButtonSelect = ({
                          disabled = false,
                          label = '',
                          menuItems = [],
                      }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);

    const handleClose = () => setAnchorEl(null);

    return (
        <div>
            <Button
                id="custom-button"
                aria-controls={open ? 'custom-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                disabled={disabled}
                variant="contained"
                endIcon={<ArrowDropDownIcon/>}
                size="small"
                sx={{
                    backgroundColor: '#186BBE',
                    boxShadow: 'none',
                    colour: '#fff',
                    '&:hover': {
                        backgroundColor: '#155FA7',
                        boxShadow: 'none',
                    },
                }}
            >
                {label}
            </Button>
            <Menu
                id="custom-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'custom-button',
                }}
            >
                {menuItems.map(({label, onClick, disabled}, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            if (onClick) {
                                onClick();
                            }

                            handleClose();
                        }}
                        disabled={disabled}
                    >
                        {label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default ButtonSelect;